<template>
  <el-container>
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>留言系统管理员角色设置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-eleme" @click="rolesSave()">保 存</el-button>
        <el-button type="info" icon="el-icon-eleme" @click="deleteRole()">删 除</el-button>
        <el-button type="info" icon="el-icon-return" @click="formReturn()">返 回</el-button>
      </el-button-group>
    </el-header>
    <el-main>
      <!--  -->
      <div style="
          font-size: 14px;
          color: #606266;
          line-height: 25px;
          margin: 15px 0;
        ">
        <el-form ref="DataFormRef" label-width="80px">
          <el-form-item label="用户名">
            {{ userRoles.userName }}
          </el-form-item>
          <el-form-item label="用户单位">
            {{ userRoles.unitName }}
          </el-form-item>
          <el-form-item label="角色设置">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities.filter((item) => item.show == true)" :label="city.value"
                :key="city.value">
                {{ city.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- <div style="text-align: center">
            <el-button type="primary" @click="rolesSave"> 保存 </el-button>
          </div> -->
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
const cityOptions = [
  { name: "系统管理员", value: "admin", show: false },
  { name: "平台管理员", value: "super", show: false },
  { name: "单位管理员", value: "manager", show: false },
];
export default {
  created() {
    this.pstApi.setWindowTitle("管理员角色设置");
    //
    // 取用户登录信息
    let user = this.pstApi.getUserData();
    this.user = user;
    // console.log(this.user);
    if (user == null) {
      //登录数据为空则返回登录界面
      this.$router.push("/Login");
    }
    // console.log(user);
    if (user.hasRoles.isAdmin) {
      cityOptions[0].show = true;
      cityOptions[1].show = true;
      cityOptions[2].show = true;
    } else if (user.hasRoles.isSuper) {
      //cityOptions[1].show = true;
      cityOptions[2].show = true;
    }
    //
    var userId = this.$route.params.id;
    this.userId = userId;
    this.getUserRoles();
  },
  data() {
    return {
      user: "",
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: false,
      userId: "",
      userRoles: "",
    };
  },
  methods: {
    formReturn() {
      this.$router.push("Supers");
    },
    getUserRoles() {
      let userId = this.userId;
      this.pstApi
        .getManager(userId)
        .then((resp) => {
          //读取成功
          this.userRoles = resp.data;
          //console.log(this.userRoles);
          this.checkedCities = this.userRoles.hasRoles.roles.split(",");
          if (this.checkedCities == null || this.checkedCities[0] == "") {
            this.checkedCities = [];
          }
          //console.log(this.checkedCities);
          let checkedCount = this.checkedCities.length;
          this.checkAll = checkedCount === this.cities.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.cities.length;
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }

          this.$toast(message);
        });
    },
    //保存角色
    rolesSave() {
      var roles = "";
      this.checkedCities.forEach((e) => {
        if (roles.length == 0) {
          roles = e;
        } else {
          roles += "," + e;
        }
      });
      //向服务器保存角色信息
      var userId = this.userRoles.userId;
      this.pstApi
        .updateManager(userId, roles)
        .then((resp) => {
          this.$toast("保存成功");
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }

          this.$toast(message);
        });
    },
    deleteRole() {
      this.$confirm("确认删除该管理员？", "提示", {
        iconClass: "el-icon-question", //自定义图标样式
        confirmButtonText: "确认", //确认按钮文字更换
        cancelButtonText: "取消", //取消按钮文字更换
        showClose: true, //是否显示右上角关闭按钮
        type: "warning", //提示类型  success/info/warning/error
      })
        .then(() => {
          //确认操作
          let userId = this.userId;
          this.pstApi
            .deleteManager(userId)
            .then((res) => {
              this.$toast("删除成功");
              this.$router.push("Supers");
            })
            .catch((err) => {
              var message = err.response.data.Message;
              if (message == null) {
                message = "服务器访问失败";
              }

              this.$toast(message);
            });
        })
        .then((data) => {
          //取消操作
        })
        .catch((err) => {
          //捕获异常
          console.log(err);
        });
    },
    handleCheckAllChange(val) {
      var arr = [];
      cityOptions.forEach((e) => {
        arr.push(e.value);
      });
      this.checkedCities = val ? arr : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
      //console.log(value);
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-input.is- .el-input__inner {
  color: #031944;
}

/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

//
.img-list {
  overflow: hidden;
  width: 100%;

  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }

    // 底部
    .img-li-b--bottom {
      margin-top: 10px;

      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }

    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }

    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);

      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }

    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }

    // 悬浮可见删除 or 放大按钮
    &:hover {

      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }

    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;

    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}

.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;

  .el-button {
    flex: 1;
  }
}
</style>